module.exports = __webpack_public_path__ + "static/img/check.eb0872ef.svg";